import { Box } from "@mui/material";
import FrameworkCategoryTable from "./FrameworkCategoryTable";
import { useFrameworkCategories } from "./FrameworkCategories.hooks";
import { DotLegalButton, DotLegalDeleteDialog, DotLegalPageHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation";
import FrameworkCategoryDialog from "./frameworkCategoryDialog/FrameworkCategoryDialog";
import DotLegalDeleteDialogWrapper from "../../common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper";
import { useUrlProvider } from "../../useUrlProvider";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider";

export interface FrameworkCategoriesProps {}

function FrameworkCategories() {
    const { permissions } = useUserContext();
    const { translateString } = useTranslation();
    const { getFrameworksUrl, getFrameworkOverviewUrl } = useUrlProvider();
    const {
        data,
        isLoading,
        onSelectCategory,
        setShowDeleteCategory,
        setShowDialog,
        id,
        onDeleteClick,
        refetch,
        selectedCategory,
        setSelectedCategory,
        showDeleteCategory,
        showDialog,
    } = useFrameworkCategories();

    return (
        <>
            <DotLegalPageHeader
                breadCrumbs={[
                    { name: translateString("frameworks"), link: getFrameworksUrl() },
                    { name: data?.frameworkName, tooltip: data?.frameworkDescription, link: getFrameworkOverviewUrl(id!) },
                    { name: translateString("categories") },
                ]}
                rightComponent={
                    permissions.frameworkPermissions.edit ? (
                        <DotLegalButton buttonType="primary" size="medium" onClick={() => setShowDialog(true)}>
                            {`${translateString("create")} ${translateString("category").toLowerCase()}`}
                        </DotLegalButton>
                    ) : undefined
                }
            />

            <FrameworkCategoryTable
                isLoading={isLoading}
                data={data?.categories}
                onUpdateCategoryClick={
                    permissions.frameworkPermissions.edit
                        ? (id) => {
                              onSelectCategory(id);
                              setShowDialog(true);
                          }
                        : undefined
                }
                onDeleteCategoryClick={
                    permissions.frameworkPermissions.edit
                        ? (id) => {
                              onSelectCategory(id);
                              setShowDeleteCategory(true);
                          }
                        : undefined
                }
            />

            {showDeleteCategory && selectedCategory && (
                <DotLegalDeleteDialogWrapper
                    open
                    onDialogClose={() => {
                        setShowDeleteCategory(false);
                        setSelectedCategory(undefined);
                    }}
                    onOkClick={onDeleteClick}
                    itemForDeletion={selectedCategory.name}
                />
            )}

            {showDialog && (
                <FrameworkCategoryDialog
                    frameworkId={id!}
                    model={selectedCategory}
                    onDialogClose={() => {
                        setShowDialog(false);
                        setSelectedCategory(undefined);
                        refetch();
                    }}
                />
            )}
        </>
    );
}

export default FrameworkCategories;
